import EditorWidget from './EditorWidget'
import PasswordWidget from './PasswordWidget'
import SwitchWidget from './SwitchWidget'

export default {
  EditorWidget,
  PasswordWidget,
  SwitchWidget
}
